import React from 'react';
import QuestionPanel from "../../structure/QuestionPanel";
import SelectDropdown from "../../input/SelectDropdown";
import NumericInput from "../../input/NumericInput";
import { PaymentPreference } from "../../enums/PaymentPreference";
import CheckGraphic from "../../../images/CheckGraphic.jpg"
import { useFormikContext } from "formik";
import { EmployeeFormValues } from "../../common/EmployeeFormValues";
import { BankAccountType } from "../../enums/BankAccountType";
import { PfmlEmployerFormValues } from "../../pfml/PfmlEmployerFormValues";
import { Party } from "../../enums/Party";
import { FormValues } from "../../common/FormValues";

const Payments = () => {
    const { values } = useFormikContext<FormValues>();

    const isEmployer = values.party === Party.EMPLOYER;
    const paymentPreference = isEmployer ? (values as PfmlEmployerFormValues)?.employerPaymentPreference : (values as EmployeeFormValues)?.paymentPreference;
    const isEft = paymentPreference === PaymentPreference.EFT;
    const isCheck = paymentPreference === PaymentPreference.CHECK;
    const isDisability = values.disability;
    const isWellness = values.wellness;
    const employerPrefix = isEmployer ? `${Party.EMPLOYER}-` : '';
    const mailingAddressMessage = isEmployer ? 'address we have on file for you' : 'residency address you provided on this form'
    return (
        <QuestionPanel headerText="How do you prefer to be paid?"
                       detailsText={
                           <>
                               We can deposit funds directly in your bank account (faster) or send you a check.
                               {isCheck &&
                                   <div>
                                       <br/>
                                       {`We will mail your check to the ${mailingAddressMessage}.`}
                                   </div>
                               }
                               {isEft &&
                                   <div>
                                       <br/>
                                       You can find your routing number and account number at the bottom of your check, or from your bank's website.
                                       <br/><br/>
                                       {isDisability
                                           && <div>Some disability policies do not currently support electronic funds transfer. If you are a member of one of these policies, you will receive your payment(s) by check.<br/><br/></div>}
                                       <img src={CheckGraphic} alt="Check graphic" style={{maxWidth: "100%", maxHeight: "100%"}} />
                                   </div>
                               }
                               {isWellness &&
                                   <div><br/>
                                       If you are eligible for multiple payments under multiple products or with multiple patients, you will
                                       receive multiple checks or electronic deposits into your account.
                                   </div>
                               }
                           </>
                       }
                       panelContent={
                           <div>
                               <SelectDropdown id={`${employerPrefix}payment-preference`} label="Payment preference" required={true}
                                               options={[
                                                   {id: "eft", text: PaymentPreference.EFT},
                                                   {id: "check", text: PaymentPreference.CHECK}
                                               ]}/>
                               {isEft
                                   && <div>
                                       <NumericInput id={`${employerPrefix}account-number`} label="Account number" required={true} maxLength={17}/>
                                       <NumericInput id={`${employerPrefix}account-number-2`} label="Re-type account number" required={true} maxLength={17}/>
                                       <NumericInput id={`${employerPrefix}routing-number`} label="Routing number" required={true} maxLength={9}/>
                                       <SelectDropdown id={`${employerPrefix}account-type`} label="Account type" required={true}
                                                       options={[
                                                           { id: "checking", text: BankAccountType.CHECKING },
                                                           { id: "savings", text: BankAccountType.SAVINGS }
                                                       ]}/>
                                   </div>}
                           </div>}
        >
        </QuestionPanel>
    )
};
export default Payments;